// TODO add enums
import currencies from "@assets/data/currencies";
import EVENT_TYPES, {EVENT_RAW_TYPES} from "@assets/data/eventTypes"

export enum EventApplicationType {
    handshake = "handshake",
    open = "open",
}

export enum EventApplicationStatus {
    open = "open",
    closed = "closed",
}

export const
    DEFAULT_EVENT_APPLICATION_TYPE = EventApplicationType.handshake,
    LIST_EVENT_APPLICATION_TYPE = [EventApplicationType.handshake, EventApplicationType.open] as const,
    DEFAULT_EVENT_APPLICATION_STATUS = EventApplicationStatus.open,
    LIST_EVENT_APPLICATION_STATUS = [EventApplicationStatus.open, EventApplicationStatus.closed] as const,
    DEFAULT_EVENT_TYPE = "sports",
    LIST_EVENT_TYPE = Object.keys(EVENT_RAW_TYPES) as Array<keyof typeof EVENT_RAW_TYPES>,
    DEFAULT_SUB_EVENT_TYPE = "soccer",
    //LIST_SUB_EVENT_TYPE = ["soccer", "ice hockey", "basketball", "tennis", "boxing", "football"] as const;
    LIST_SUB_EVENT_TYPE = Object.values(EVENT_RAW_TYPES).flatMap(group => group.categories.map(cat => cat.value)) as string[];

export const CURRENCIES = currencies as readonly {
    readonly symbol: string;
    readonly name: string;
    readonly symbol_native: string;
    readonly decimal_digits: number;
    readonly rounding: number;
    readonly code: string;
    readonly name_plural: string;
}[]
export const VALID_CURRENCIES = CURRENCIES.map(l => l.code) as typeof CURRENCIES[number]["code"][];
export const DEFAULT_CURRENCY = "EUR"; // Default language

export const getSubTypesByType = (type: string) => {
    if(!type) {
        return [];
    }
    const group = EVENT_RAW_TYPES[type].categories;
    if (group) {
        return group;
    }
    return [];
}

export type EventApplicationStatusType = (typeof LIST_EVENT_APPLICATION_STATUS)[number];
